import * as React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Create, FormManager, PageTitle, selectUser, UserState } from 'gossamer-front-end';
import { getListRowLink } from 'gossamer-unified';
import { LocationTrackingSchedule } from 'cb-model';
import { useSelector } from 'react-redux';
import { CustomInfo } from 'cb-unified';

export const LocationTrackingScheduleCreate = (): React.JSX.Element => {
  const navigate = useNavigate();
  const user = useSelector((state: { user: UserState }) => selectUser(state));
  const [searchParams] = useSearchParams();
  const institutionGroupId = searchParams.get('institution_group_id');
  const locationId = searchParams.get('location_id');

  return (
    <>
      <PageTitle verb="Create" entity={LocationTrackingSchedule} />
      {user.userId && (
        <FormManager
          compoundUrl="/main/~/location-tracking-schedule-create"
          handleCancel={() => navigate(`/admin/location-tracking-schedule/search`)}
          handleSuccess={({ keyOfFirstCreate }) =>
            navigate(getListRowLink(LocationTrackingSchedule.listRowLink, keyOfFirstCreate))
          }
          initialization={{
            main: {
              type: 'create-single',
              entity: LocationTrackingSchedule,
              override: {
                institution_id: (user.customInfo as CustomInfo)?.adminInstitutionId,
                ...(institutionGroupId ? { institution_group_id: parseInt(institutionGroupId) } : {}),
                ...(locationId ? { location_id: parseInt(locationId) } : {}),
              },
            },
          }}
        >
          <Create valuesKey="main" entity={LocationTrackingSchedule} />
        </FormManager>
      )}
    </>
  );
};
